@if(!errorLoadItemById)
{

<ng-container *ngIf="isLoading(); else content">


    <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading item" />
    </div>
</ng-container>


<ng-template #content>

            <div class="container mx-auto mt-10 md:mt-20 px-4 lg:px-20 min-h-auto ">
                <app-custom-breadcrumb [isColorLight]="true" [separatorIsChevron]="true"></app-custom-breadcrumb>
                <div class="w-full  flex justify-end">
                    <div class="flex items-center gap-2">
                        <a (click)="openPopupCenter(facebookShareUrl(), 'popUpWindow', 550, 550)">
                            <fa-icon [icon]="faFacebook"
                                style="color: #0866ff; cursor: pointer; font-size: 24px; margin-right: 10px;"
                                aria-label="Share to Facebook Logo"></fa-icon>
                        </a>
                        <a [href]="twitterShareUrl()" target="_blank">
                            <fa-icon [icon]="faXTwitter" style="color: black; font-size: 24px; margin-right: 10px;"
                                aria-label="Share to Twitter Logo"></fa-icon>
                        </a>
                        <a [href]="linkedinShareUrl()" target="_blank">
                            <fa-icon [icon]="faLinkedin" style="color: #0077B5; font-size: 26px; margin-right: 10px;"
                                aria-label="Share to LinkedIn Logo"></fa-icon>
                        </a>
                        <div [cdkCopyToClipboard]="copyUrl()" (cdkCopyToClipboardCopied)="onCopyUrl()" class="clickable-div h-26px w-26px">
                            <fa-icon [icon]="faLink" style="color: rgba(74, 74, 74, 1); font-size: 22px !important; "
                                aria-label="Copy URL"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col md:flex-row  gap-7  pt-8  md:pt-[58px]">

                    <div class="md:w-1/2 flex flex-col items-center max-w-[350px] mx-auto md:mx-0">
                        <app-gallery-full-image [gallery]="gallery" [itemModal]="itemModal" [isCommunity]="true">
                        </app-gallery-full-image>
                    </div>

                    <div class="md:w-1/2 flex flex-col justify-between">
                        <div>
                            <h1 class="text-[var(--dark-blue)] font-noto-serif font-medium text-lg cursor-pointer hover:underline"
                                [routerLink]="['/auction', itemModal?.auctionId]">{{
                                itemModal?.organizationName }}
                            </h1>
                            <p class=" text-[var(--light-gray)] text-xs font-medium">{{ itemModal?.category }}</p>
                            <div class="flex items-center">
                                <h3 class="text-[var(--dark-blue)] font-noto-serif text-2xl font-medium"
                                    [innerHTML]="itemModal?.name | sanitizeHtmlText"> </h3>
                                <fa-icon [icon]="isFavorited ? faBookmarkSolid : faBookmarkRegular"
                                    class="ml-2 text-blue-500 text-lg cursor-pointer"
                                    (click)="isAuthenticated().isAuthenticated ? toggleFavorite() : openLoginModalFavorite()"></fa-icon>
                            </div>

                            <div class=" flex flex-wrap items-center gap-1 lg:gap-4 text-gray-700 mt-3">
                                @if (itemModal?.isBiddable || itemModal?.isBuyable) {

                                <div class="flex items-center">
                                    <span class="text-[var(--fs-dark)] font-dm-sans text-lg font-medium">
                                        {{ itemModal?.isBuyable && !itemModal?.currentLeadingBid ? itemModal?.buyNowPrice :
                                        itemModal?.currentLeadingBid }}
                                    </span>
                                    <span class="text-[var(--sky-blue)] font-dm-sans text-lg ml-4">
                                        {{
                                        itemModal?.isBiddable
                                        ? (itemModal?.numberOfBids === 0 ? 'Opening Bid' : 'Leading Bid')
                                        : (itemModal?.isBuyable ? 'Buy Now' : 'Leading Bid')
                                        }}
                                    </span>
                                </div>

                                <ng-container *ngIf="itemModal?.hasReserve">
                                    <div class="flex justify-center items-center  cursor-pointer " (click)="openReserveModal()">
                                        <ng-container *ngIf="itemModal?.isAboveReserve; else notMet">
                                            <fa-icon [icon]="faSquareCheck "
                                                class="text-sm text-lime-600   font-bold"></fa-icon>
                                            <h2 class=" text-base font-medium ml-2 ">Reserve Met</h2>
                                        </ng-container>

                                        <ng-template #notMet>
                                            <fa-icon [icon]="faLock " class="text-orange-600 text-base font-bold"></fa-icon>
                                            <h2 class=" text-base font-medium   ">Reserve Not Met</h2>
                                        </ng-template>
                                    </div>
                                </ng-container>
                                }

                            </div>

                            <div class=" flex items-center mt-1 mb-3">
                                @if(itemModal?.myMaxBid != null && itemModal?.isLeader)
                                {
                                <div class="text-[var(--fs-dark)] font-dm-sans text-lg ">
                                    {{itemModal?.myMaxBid}} <span class="text-[var(--sky-blue)] font-dm-sans text-lg ml-4">My
                                        Maximum
                                        Bid</span>
                                </div>
                                }

                                <!-- @if(itemModal && itemModal.isLeader)
                            {
                            <div class="flex items-center  px-3 py-1 text-xs font-semibold h-7 ">
                                <fa-icon [icon]="faCrown" class="mr-1 text-lg  text-[var(--fs-forest)]"></fa-icon>
                                You're Leading
                            </div>
                            } -->

                            </div>

                            <p>
                                <span *ngIf="itemModal?.estimatedValue; else noEstimatedValue" class="text-[#6E6E6E] text-sm">
                                    {{ isAmountEstimatedValue(itemModal!.estimatedValue) ? itemModal?.estimatedValue + '
                                    Estimated Value' :
                                    'Priceless' }}
                                </span>
                                <ng-template #noEstimatedValue>
                                    <span class="text-gray-500 text-xs invisible">-</span>
                                </ng-template>
                            </p>


                        </div>


                        @if(postBiddingLoading){

                        <div class="flex items-center justify-center min-h-[300px]">
                            <p-progress-spinner ariaLabel="loading item" />
                        </div>

                        }@else{





                        <!-- switch item type buy, bid, buy-now -->

                        <ng-container [ngSwitch]="itemType">
                            <ng-container *ngSwitchCase="'buy'">
                                <!-- falta un div 420-->
                                <div class="flex flex-col md:flex-row gap-2 w-full mt-4">
                                    <div class="flex-1">
                                        <label
                                            class="font-dm-sans font-medium text-[var(--charcoal)] tracking-wide  ">Quantity</label>
                                        <p-inputNumber [(ngModel)]="quantity" [min]="1" [max]="itemModal?.quantityAvailable"
                                            mode="decimal" showButtons
                                            class="w-full  text-gray-500 text-xs h-[35px] mb-2 "></p-inputNumber>
                                        <span class=" font-dm-sans font-medium text-[var(--bc-teal)] ">Only {{
                                            itemModal?.quantityAvailable }}
                                            available</span>
                                    </div>

                                    <div class="flex-1 sm:w-[90px]">
                                        <label
                                            class="block text-[var(--charcoal)] font-dm-sans  font-medium tracking-wide">Total</label>
                                        <input
                                            [value]="itemModal?.currentLeadingBid ? itemModal?.currentLeadingBid : itemModal?.buyNowPrice"
                                            class="w-full bg-gray-100 text-gray-500 border border-gray-300 rounded-lg p-2 text-xs h-[35px] "
                                            readonly>
                                    </div>
                                </div>
                                <button pButton
                                    class="!bg-[var(--community-info-500)] !border-[var(--community-info-500)] 
                    hover:!bg-[var(--community-info-600)] hover:!border-[var(--community-info-600)] 
                    active:!bg-[var(--community-info-700)] active:!border-[var(--community-info-700)] mt-6 w-full lg:h-[35px] relative flex items-center justify-center"
                                    (click)="isAuthenticated().isAuthenticated ? embeddedPaymentLoad() : openLoginModal() ">
                                    <i class="pi !text-[var(--p-text-color-secondary)] absolute left-3"
                                        [ngClass]="itemModal?.isBiddable || itemModal?.isBuyable ? 'pi-credit-card' : 'pi-bookmark'">
                                    </i>
                                    <span class="font-mulish !text-[var(--p-text-color-secondary)] text-center w-full">
                                        Buy Now
                                    </span>
                                </button>
                                <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>

                                <div class="flex flex-col md:flex-row justify-between md:items-center mt-4">
                                    <div class="flex items-center gap-2">
                                        <fa-icon [icon]="iconUserGroup"
                                            class="text-[var(--sky-blue)] font-bold text-xs"></fa-icon>
                                        <span class="font-dm-sans  font-medium text-[var(--charcoal)] text-xs">
                                            {{itemModal?.numberSold === 0 ? 'Be first in line to buy!' :
                                            itemModal?.numberSold + ' people already purchased this item' }}
                                        </span>
                                    </div>

                                    <div class="flex items-center gap-2">
                                        <fa-icon [icon]="iconCalendar"
                                            class="text-[var(--sky-blue)] font-bold text-xs"></fa-icon>
                                        <span class="font-dm-sans  font-medium text-[var(--charcoal)] text-xs">{{
                                            itemDateFormat()}}</span>
                                    </div>
                                </div>

                                <div *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] block ">
                                    <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'bid'">
                                <ng-container *ngIf="!showConfirmTemplate && !showBidStatus">
                                    <ng-template [ngTemplateOutlet]="bidControls"></ng-template>
                                </ng-container>

                                <ng-container *ngIf="showConfirmTemplate && !showBidStatus">
                                    <ng-template [ngTemplateOutlet]="bidConfirmTemplate"></ng-template>
                                </ng-container>

                                <ng-container *ngIf="showBidStatus">
                                    <ng-template *ngTemplateOutlet="bidStatusTemplate"></ng-template>
                                </ng-container>
                            </ng-container>

                            <!-- buy and bid  -->
                            <ng-container *ngSwitchCase="'buy-bid'">
                                <ng-container *ngIf="!showConfirmTemplate && !showBidStatus">
                                    <ng-template [ngTemplateOutlet]="bidControls"></ng-template>
                                </ng-container>

                                <ng-container *ngIf="showConfirmTemplate && !showBidStatus">
                                    <ng-template [ngTemplateOutlet]="bidConfirmTemplate"></ng-template>
                                </ng-container>

                                <ng-container *ngIf="showBidStatus">
                                    <ng-template *ngTemplateOutlet="bidStatusTemplate"></ng-template>
                                </ng-container>

                                <button *ngIf="!showConfirmTemplate && !showBidStatus" pButton
                                    class=" mt-6 w-full relative flex items-center justify-center h-[35px]"
                                    (click)="embeddedPaymentLoad()" [ngClass]="{'rounded': themeType === 'bfg'}">
                                    <fa-icon [icon]="faCreditCard"></fa-icon>
                                    <span class="font-mulish !text-[var(--p-text-color-secondary)] text-center w-full">
                                        Buy Now {{ itemModal?.buyNowPrice }} {{currency()}}
                                    </span>
                                </button>
                                <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>
                            </ng-container>

                            <!-- sold -->
                            <ng-container *ngSwitchCase="'sold'">
                                <div class=" mt-4">
                                    <div
                                        class="bg-orange-200 rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                        <h3 class="text-base font-mulish  font-semibold mb-1">Out Stock!</h3>
                                    </div>

                                    <ng-container class="" *ngTemplateOutlet="biddingNoPlaced"></ng-container>

                                </div>
                            </ng-container>

                            <!-- event  -->
                            <ng-container *ngSwitchCase="'event'">
                                <div class=" mt-4">
                                    <div class="bg-[#DFE7EF] rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                        <h3 class="text-base font-mulish  font-semibold mb-1">Live Event Item</h3>
                                        <p class="text-sm font-mulish  text-center">
                                            <span> You can place your bid on the item exclusively at the live event
                                                on</span> {{ openingDateFormat()}}
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingNoPlaced"></ng-container>
                                </div>
                            </ng-container>

                            <!-- online  -->
                            <ng-container *ngSwitchCase="'online'">
                                <div class=" mt-4">
                                    <div class="bg-lime-200 rounded-md p-4 flex flex-col justify-center items-center  min-h-32">
                                        <h3 class="text-base font-mulish  font-semibold mb-1">Online Open</h3>
                                        <p class="text-sm font-mulish  text-center">
                                            <span>This item will be available on</span> {{ openingDateFormat()}}
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingNoPlaced"></ng-container>
                                </div>
                            </ng-container>

                            <!-- upcoming -->
                            <ng-container *ngSwitchCase="'upcoming'">
                                <div class=" mt-4">
                                    <div class="bg-lime-100 rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                        <h3 class="text-base font-mulish  font-semibold mb-1">Online Open</h3>
                                        <p class="text-sm font-mulish  text-center">
                                            <span>This item will be available on</span> {{ openingDateFormat()}}
                                        </p>
                                    </div>

                                    <ng-container class="" *ngTemplateOutlet="biddingNoPlaced"></ng-container>

                                </div>
                            </ng-container>

                            <!-- closed -->

                            <ng-container *ngSwitchCase="'closed'">
                                <div class=" mt-4">
                                    <div
                                        class="bg-orange-200 rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                        <h3 class="text-base font-mulish  font-semibold mb-1">Item Closed</h3>
                                        <p class="text-sm font-mulish  text-center">
                                            <span>This item closed on</span> {{ itemDateFormat()}}
                                        </p>
                                    </div>

                                    <button pButton
                                        class="!bg-[var(--community-info-500)] !border-[var(--community-info-500)] 
                    hover:!bg-[var(--community-info-600)] hover:!border-[var(--community-info-600)] 
                    active:!bg-[var(--community-info-700)] active:!border-[var(--community-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                        [rounded]="true" (click)="toggleFavorite()">
                                        <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
                                        </i>
                                        <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                                            {{ itemFavoriteSignal() ? 'Remove to my Favorites' : 'Add to my Favorites' }}
                                        </span>
                                    </button>
                                    <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                        <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                    </p>
                                </div>
                            </ng-container>

                        </ng-container>

                        }

                        <!-- template bid controls -->
                        <ng-template #bidControls>
                            <div class="">
                                @if(isAuthenticated().isAuthenticated){
                                <div class="flex flex-col md:flex-row gap-4 w-full">

                                    <div class="flex-1">
                                        <p class="font-dm-sans  text-[var(--charcoal)] text-base m-0">{{myBidLabel}}
                                        </p>
                                        <input pInputText [(ngModel)]="selectedBid" [placeholder]="bidPlaceholder"
                                            class="w-full pl-3 text-sm h-[40px] placeholder:text-[12px] placeholder:text-gray-100 border border-gray-300 rounded-md"
                                            (input)="showLowBidError = false" pattern="[0-9]+" #bidInput="ngModel">
                                        @if (bidInput.invalid && (bidInput.dirty || bidInput.touched)) {
                                        <p-message severity="error" size="small">
                                            Please enter a whole amount, without symbols or letters.
                                        </p-message>
                                        }
                                    </div>

                                    <div class="flex-1">
                                        <label class="font-dm-sans  text-[var(--charcoal)] text-base">Credit
                                            Card</label>
                                        <p-select [options]="cardOptions()" [(ngModel)]="selectedCardId" placeholder=""
                                            optionLabel="label" optionValue="value" class="w-full h-[40px]"
                                            [style]="{ 'fontSize': '12px' ,color: '#6B7280'  }"></p-select>
                                        <button class="flex items-center space-x-2 text-custom-blue font-semibold mt-1"
                                            (click)="onAddCreditCard()">
                                            <i class=" pi pi-credit-card"></i>
                                            <span class="text-xs">Add New Credit Card</span>
                                        </button>
                                    </div>
                                </div>

                                <div class="flex flex-col md:flex-row justify-between  md:items-center mt-5">

                                    <div class=" flex items-center">
                                        <p-radioButton name="bidProxy" value="PROXY" [(ngModel)]="selectedBidOption"
                                            class="mr-1 scale-75  text-lg"></p-radioButton>
                                        <span class="font-dm-sans  font-medium text-[var(--charcoal)] ">Bid up this
                                            amount</span>
                                    </div>


                                    <div class="flex items-center">
                                        <p-radioButton name="bidStraight" value="STRAIGHT" [(ngModel)]="selectedBidOption"
                                            class="mr-1 scale-75  text-lg"></p-radioButton>
                                        <span class="font-dm-sans  font-medium text-[var(--charcoal)]">Bid exactly this
                                            amount</span>


                                        <span
                                            class="pi pi-question-circle text-[var(--sky-blue)] cursor-pointer ml-2 block md:hidden"
                                            title="More info" (click)="onQuestionMark()"></span>
                                    </div>


                                    <div class="hidden md:flex items-center">
                                        <fa-icon [icon]="faCircleQuestion" class="text-[var(--sky-blue)] cursor-pointer"
                                            title="More info" (click)="onQuestionMark()"></fa-icon>
                                    </div>
                                </div>

                                <button pButton
                                    class=" mt-6 lg:h-[35px]  w-full relative flex items-center justify-center"
                                    [ngClass]="{'rounded': themeType === 'bfg'}" (click)="validateBid()">
                                    <fa-icon [icon]="faCreditCard" class="!text-white "></fa-icon>
                                    <span class="font-mulish !text-white text-center w-full">
                                        Place a Bid
                                    </span>
                                </button>

                                @if(itemModal!.biddingType === 'ONLINE_AND_LIVE'){
                                <ng-container *ngTemplateOutlet="OnlineToLiveEvent"></ng-container>
                                }

                                @if (errorMessage != null && errorMessage !== "") {
                                <p-message severity="error">
                                    {{ errorMessage }}
                                </p-message>
                                }
                              
                                @if (creditCardErrorMessage !== '') {
                                    <div class="text-red-500 text-sm mt-1">
                                        {{creditCardErrorMessage}}
                                    </div>
                                }

                                <div *ngIf="showLowBidError" class="text-red-500 text-sm mt-1">
                                    Your bid of {{selectedBid}} is lower than the minimum bid required.
                                </div>

                                <div *ngIf="showMaxBidError" class="text-red-500 text-sm mt-1">
                                    Your bid must be higher than your current maximum bid {{ itemModal?.myMaxBid }}.
                                </div>

                                <ng-container *ngTemplateOutlet="bidsPlacedInfo"></ng-container>


                                }@else {
                                @if (isShowingLoginIframe()) {
                                <div class="border border-solid border-[var(--p-primary-500)] rounded-xl">
                                    <app-sign-in [loginPage]="loginPage" [loginUrl]="loginUrl()"></app-sign-in>
                                </div>
                                } @else {
                                <div>
                                    <button pButton
                                        class="mt-6  w-full lg:h-[35px] relative flex items-center justify-center"
                                        (click)="showLoginIframe()">
                                        <i class="pi !text-[var(--p-text-color-secondary)] absolute left-3" [ngClass]="'pi-user'">
                                        </i>
                                        <span class="font-mulish !text-[var(--p-text-color-secondary)] text-center w-full">
                                            Sign In To Bid
                                        </span>
                                    </button>
                                </div>
                                }
                                }

                            </div>
                        </ng-template>

                        <!-- bid confirm template  -->
                        <ng-template #bidConfirmTemplate>
                            <ng-container *ngIf="showConfirmTemplate">
                                <div class=" mt-4">
                                    <div
                                        class="bg-[rgba(25,166,223,0.2)] border border-[var(--fs-blue)] rounded-xl p-6 text-center">
                                        <h3 class="text-xl font-bold mb-2 text-[var(--dark-blue)]"> Confirm Bid</h3>
                                        <p class="text-sm  text-center text-[var(--dark-blue)]  font-medium   lg:ml-16">
                                            Please confirm your maximum bid of ${{selectedBid}} {{currency()}} using credit card
                                            {{ selectedCardName() }}.
                                        </p>
                                        
                                        @if(showCoverTheFee())
                                        {
                                              <div class="flex items-center gap-2 mt-4">
                                            <input type="checkbox" id="chkCoverFee" class="  " [(ngModel)]="coverFeeConfirm" />
                                            <label for="coverFee"
                                                class="text-gray-500 text-[11px]  text-[var(--dark-blue)]  font-medium ml-1 text-left">
                                                I'd like to cover the fee so 100% of my bid goes to the nonprofit
                                                (${{feeAmountSignal()}}
                                                {{currency()}}
                                                estimated). The fee will be based on the final winning bid amount.
                                            </label>
                                        </div>
                                        }                                      
                                    </div>

                                    <div *ngIf="showLowBidError" class="text-red-500 text-sm mt-1">
                                        Your bid of {{selectedBid}} is lower than the minimum bid required.
                                    </div>

                                    <div class="mt-6 flex flex-col md:flex-row gap-2 ">
                                    <button pButton
                                            class=" h-[40px] lg:h-[35px] !bg-white  px-4 py-2 font-medium text-base flex-[1]   flex justify-end items-center"
                                            (click)="onClickBack()">
                                            <i class="fa-solid fa-circle-check  text-white text-lg left-3">
                                            </i>
                                            <span
                                                class="font-noto-serif font-medium text-[#528BBA] text-center w-full text-base ">
                                                Back
                                            </span>
                                        </button>

                                        <button pButton
                                            class=" relative flex-[1] items-center justify-center gap-2 h-[35px]"
                                            (click)="placeABid()">
                                            <i class="fa-solid fa-circle-check !text-[var(--p-text-color-secondary)] text-lg left-3">
                                            </i>
                                            <span class=" font-noto-serif font-medium !text-[var(--p-text-color-secondary)] text-center w-full text-base ">
                                                Confirm
                                            </span>
                                        </button>
                                    </div>

                                    @if (errorMessage != null && errorMessage !== "") {
                                    <p-message severity="error">
                                        {{ errorMessage }}
                                    </p-message>
                                    }

                                    <ng-container *ngTemplateOutlet="bidsPlacedInfo"> </ng-container>

                                </div>
                            </ng-container>
                        </ng-template>

                        <!-- template status  bidding -->

                        <ng-template #bidStatusTemplate>
                            <ng-container [ngSwitch]="bidResponseSignal()">
                                <ng-container *ngSwitchCase="'LEADER_PROXY_BID'">
                                    <div class="bg-[#D4ECD5] rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                        <h3 class="text-lg  font-semibold mb-1 text-[#357B38]">Congratulations!</h3>
                                        <p class="text-sm text-center mt-4 text-[#357B38]">
                                            You are currently the
                                            <span class="font-bold">Leader</span> for item
                                            <span class="font-bold">{{ itemModal?.name }}</span> with a
                                            <span class="font-bold">Leading Bid of {{ itemModal?.currentLeadingBid}}
                                                {{currency()}}.</span>
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingButtons"></ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="'LEADER_STRAIGHT_BID'">
                                    <div class="bg-[#D4ECD5] rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                        <h3 class="text-lg  font-semibold mb-1 text-[#357B38]">Congratulations!</h3>
                                        <p>
                                            Your <span class="font-bold">Straight Bid of $ {{ selectedBid}} {{currency()}}
                                            </span>
                                            has been
                                            recorded.
                                        </p>
                                        <p class="text-sm text-center  text-[#357B38]">You are currently the
                                            <span class="font-bold">Leader</span> for item <span class="font-bold">{{
                                                itemModal?.name }}</span> with a
                                            <span class="font-bold">Leading Bid of $ {{ selectedBid}} {{currency()}}.</span> If
                                            you
                                            win, a
                                            fee will be added to your winning bid (${{ feeAmountSignal()}}
                                            {{currency()}} estimated). The final
                                            fee will
                                            be
                                            based on the winning bid amount.
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingButtons"></ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="'LEADER_BELOW_RESERVE'">
                                    <div
                                        class="bg-[#FEF0CD] border border-[#B08620] rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                        <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#644D12]"> Your Bid is Below
                                            Reserve!
                                        </h3>
                                        <p class="text-sm text-center  mt-4 text-[#B08620]">
                                            Your bid of $ {{ selectedBid}} {{currency()}} was successful but below the Reserve
                                            Price, which
                                            is the minimum
                                            amount the seller will accept. Since the reserve wasn't met, the item won't be sold.
                                            You need to place a higher bid to win.
                                        <p class="text-sm  font-bold  text-[#B08620] pt-4">You are currently the
                                            Please try again with a higher bid!
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingButtons"></ng-container>


                                </ng-container>

                                <ng-container *ngSwitchCase="'OUTBID'">
                                    <div
                                        class="bg-gray-200 border border-gray-300 rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                        <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#644D12]"> Outbid!
                                        </h3>
                                        <p class="text-sm text-center mt-4 text-[#B08620] font-semibold">
                                            Your bid was successful, but you've been outbid!
                                        <p class="text-sm  text-[#B08620] pt-4">
                                            Your max bid of ${{selectedBid}} {{currency()}} matched another bidder's earlier max
                                            bid,
                                            so they’re still in the lead. <strong>Bid again to take the lead!.</strong>
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingButtons"></ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="'TIE_LOSER'">
                                    <div
                                        class="bg-gray-200 border border-gray-300 rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                        <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#644D12]"> Outbid!
                                        </h3>
                                        <p class="text-sm text-center  mt-4 text-[#B08620] font-semibold">
                                            Your bid was successful, but you've been outbid!
                                        <p class="text-sm  font-bold  text-[#B08620] pt-4">We bid up to your <strong>
                                                Maximum Bid
                                                of ${{selectedBid}} {{currency()}} </strong> but another bidder had already
                                            placed a higher
                                            <strong>Maximum Bid.</strong>

                                            If you want to win this item, <strong>please bid again!</strong>
                                        </p>
                                    </div>
                                    <ng-container class="" *ngTemplateOutlet="biddingButtons"></ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-template>


                    </div>
                </div>


                <!-- tabs -->
                            <div class="flex flex-col md:flex-row  max-w-[1200px] mt-10 md:mt-20 mb-8">
                                <p-tabs [(value)]="activeTab" class=" w-full" [scrollable]="true" (valueChange)="onTabChange($event)">
                                    <p-tablist>
                                        <p-tab *ngFor="let tab of filteredTab" [value]="tab.value"
                                            class=" font-dm-sans  font-bold text-sm md:text-base ">{{
                                            tab.title
                                            }}</p-tab>
                                    </p-tablist>

                                    <p-tabpanels>
                                        <p-tabpanel *ngFor="let tab of filteredTab " [value]="tab.value">
                                            <ng-container *ngIf="tab.value === 0">
                                                <div class="flex flex-col md:flex-row gap-8">
                                                    <div class="flex-1 pr-8">
                                    <h3 class="font-noto-serif font-bold text-lg text-[var(--fs-dark)]"> Description
                                    </h3>
                                    <h1 class="mt-4 font-dm-sans  text-[var(--fs-dark)]"
                                        [innerHTML]="itemModal?.description | sanitizeHtmlText"></h1>
                                </div>
                                @if (itemModal && itemModal.specialNote && itemModal.specialNote.toString().length > 0)
                                {
                                <div class="flex-1 ">
                                    <h3 class="font-noto-serif font-bold text-lg text-[var(--fs-dark)]">Item Special
                                        Note
                                    </h3>
                                    <h1 class="mt-4 font-dm-sans  text-[var(--fs-dark)]"
                                        [innerHTML]="itemModal.specialNote | sanitizeHtmlText"></h1>
                                </div>
                                }
                            </div>

                            @if(itemModal && itemModal.donors.length > 0){
                            <div class="mt-12">
                                <h3 class="font-noto-serif text-xl font-bold">Generously donated by</h3>
                                <p class="font-dm-sans text-[var(--fs-dark)] ">With immense gratitude, we acknowledge
                                    the
                                    generous contributions
                                    that make this
                                    event possible.</p>
                                <div class="w-full">
                                    <app-donors [donors]="itemModal.donors"></app-donors>
                                </div>
                            </div>
                            }
                            </ng-container>
                            <ng-container *ngIf="tab.value === 1">
                                <h2 class="text-base font-semibold">Ask a question about this item</h2>
                                <div class="flex flex-col w-full">
                                    <span class="text-gray-600 font-semibold text-[14px] mt-4">Your Question</span>
                                    <textarea pInputTextarea rows="5" class="w-full mt-2" [(ngModel)]="askAQuestionControl"
                                        (input)="onQuestionChange()"></textarea>
                                </div>
                                <small class="text-red-500 block min-h-[1rem]" *ngIf="responseError">
                                    {{ responseError }}
                                </small>

                                <div class="flex justify-end mt-4">
                                    <button pButton class="text-white font-noto-serif  mt-6 w-[160px] h-[40px]"
                                                            (click)="onAskAQuestion()">
                                                            Send
                                                        </button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="tab.value === 2">
                                <div class="w-full flex flex-col flex-1 min-h-0">
                                    <h2 class="text-base font-semibold">Frequently Asked Questions</h2>
                                    <div class="mt-4 w-full flex-1">
                                        <p-accordion class="w-full max-w-full">
                                            @for (faq of faqs; track faq.question) {
                                            <p-accordion-panel [value]="faq.value">
                                                <p-accordion-header class="text-sm">{{ faq.question }}</p-accordion-header>
                                                <p-accordion-content>
                                                    <p class="m-0">{{ faq.answer }}</p>
                                                </p-accordion-content>
                                            </p-accordion-panel>
                                            }
                                        </p-accordion>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="tab.value === 3">
                            <div>
                                <h2 class="font-bold text-xl text-[var(--fs-dark)]"> Item Bid History </h2>

                                <div class="flex items-center gap-3">
                                    <p class="font-semibold ">{{itemModal?.name}}</p>
                                    <p class="text-xs">(Item Number {{itemModal?.lotNumber}})</p>
                                </div>
                            </div>



                            @if(!errorLoadingBidHistory)
                            {
                            <div class="flex flex-col-reverse md:flex-col">
                                <a href="https://support.frontstream.com/hc/en-us/articles/115005888343-Understanding-Bid-Histories-Bid-Increments"
                                    class="text-sm text-end">More Info on bid increments & bid
                                    histories</a>

                                <div class=" hidden md:block">
                                    <table class="w-full border border-gray-200 mt-6">
                                        <thead class="bg-blue-100 text-sm">
                                            <tr>
                                                <th class="text-center px-4 py-2">Placed On</th>
                                                <th class="text-center px-4 py-2">Placed By</th>
                                                <th class="text-center px-4 py-2">$</th>
                                                <th class="text-center px-4 py-2 hidden md:block">Details</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-200 text-sm ">
                                            <tr *ngFor="let bid of formatBidHistory">
                                                <td class="px-4 py-2 text-center">{{ bid.placedOn }}</td>
                                                <td class="px-4 py-2 text-center"
                                                    [ngClass]=" {'font-bold': bid.placedBy === userName && isAuthenticated().isAuthenticated} ">
                                                    {{
                                                    bid.placedBy }}</td>

                                                <td class="px-4 py-2 text-center">{{ bid.amount }}</td>
                                                <td class="p-3 hidden md:block">
                                                    <ng-container *ngFor="let caption of bid.captions">
                                                        <button
                                                            (click)="activeCaption = caption; openCaptionModal(caption, bid)"
                                                            class="text-blue-500 hover:underline block w-full mb-1 text-center">
                                                            {{ caption | captionBid }}
                                                        </button>
                                                    </ng-container>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- vertical  -->

                                <div class="md:hidden overflow-x-auto mt-2">
                                    <div *ngFor="let bid of formatBidHistory"
                                        class="border-b rounded-md shadow-sm bg-white text-sm space-y-1 mt-4 mb-10">
                                        <p>
                                            <span class="font-bold text-gray-600">Placed On:</span>
                                            <span class="text-gray-500"> {{ bid.placedOn }}</span>
                                        </p>
                                        <p>
                                            <span class="font-bold text-gray-600">Placed By:</span>
                                            <span class="text-gray-500"> {{ bid.placedBy }}</span>
                                        </p>
                                        <p>
                                            <span class="font-bold text-gray-600">Amount:</span>
                                            <span class="text-gray-500"> {{ bid.amount }}</span>
                                        </p>
                                        <ng-container *ngFor="let caption of bid.captions">
                                            <button (click)="activeCaption = caption; openCaptionModal(caption, bid)"
                                                class="text-blue-500 hover:underline block text-left">
                                                {{ caption | captionBid }}
                                            </button>
                                        </ng-container>
                                    </div>
                                </div>
                                </div>
                            }@else{
                            <ng-container *ngTemplateOutlet="tplLoadError"></ng-container>
                        }
                        </ng-container>
                    </p-tabpanel>

                </p-tabpanels>
            </p-tabs>

            <app-bidding-question-mark (close)="onModalClose()" [visible]="displayQuestionModal">
            </app-bidding-question-mark>

            <!-- bid history modals explanations  -->
            <app-straight-bid [visible]="displayStraigthBidModal"
                (close)="onModalExplanationClose()"></app-straight-bid>
            <app-tie-bid [visible]="displayTieWinBidModal" (close)="onModalExplanationClose()"
                [tieExplanation]="tieDetails"></app-tie-bid>
            <app-reserve-met [visible]="displayReserveMetBidModal"
                (close)="onModalExplanationClose()"></app-reserve-met>
            <app-below-reserve-bid [visible]="displayBelowReserveBidModal"
                (close)="onModalExplanationClose()"></app-below-reserve-bid>
        </div>


    </div>

    <ng-template #FGFwording>
       <p class="text-sm text-[var(--charcoal)] font-dm-sans font-medium mt-4">
  The winning bid will go to
  <a href="https://frontstreamglobalfund.org/" class="text-blue-500 underline">
    FrontStream Global Fund
  </a>
  (tax ID 26-3265577), a 501c3 nonprofit organization, which will send the donation to
  {{ homePageSignal()?.orgName }} (tax ID {{ homePageSignal()?.taxId }}) on behalf of the winner.
</p>
    </ng-template>

    <ng-template #bidsPlacedInfo>
        <div class="flex flex-col md:flex-row justify-between md:items-center mt-4">
            <div class="flex items-center gap-2">
                <fa-icon [icon]="iconUserGroup" class="text-[var(--sky-blue)] font-bold text-sm"></fa-icon>
                <span class="font-dm-sans  font-medium text-[var(--charcoal)] text-sm">
                    {{itemModal?.numberOfBids === 0 ? 'Be the first to bid!' :
                    itemModal?.numberOfBids + ' bids have been placed.' }}
                </span>
            </div>

            <div class="flex items-center gap-2">
                <fa-icon [icon]="iconCalendar" class="text-[var(--sky-blue)] font-bold text-sm"></fa-icon>
                <span class="font-dm-sans  font-medium text-[var(--charcoal)] text-sm">{{
                    itemDateFormat()}}</span>
            </div>
        </div>

        <p *ngIf="showWinningBidText()">
            <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
        </p>
    </ng-template>

    <ng-template #biddingButtons>
        <div class="flex flex-col md:flex-row mt-4 gap-4">

             <button pButton
                class="mt-2 md:mt-0  h-[40px] lg:h-[35px] !bg-white !border  px-4 py-2 font-medium text-base flex-[1]   flex justify-end items-center">
                <i class="fa-solid fa-circle-check  text-lg left-3">
                </i>
                <span class="font-noto-serif font-medium text-[var(--dark-blue)]  text-center w-full text-base "
                    [routerLink]="getCatRouterLink(itemModal?.topLevelCategory ?? '')"
                    [queryParams]="getCatQueryParams(itemModal?.topLevelCategory ?? '')">
                    Back to Items
                </span>
            </button>


            <button pButton class=" flex-[1]  h-[35px] relative  flex items-center justify-center gap-2"
                (click)="resetVariables()">
                <i class="fa-solid fa-circle-check !text-[var(--p-text-color-secondary)] text-lg left-3">
                </i>
                <span class=" font-noto-serif font-medium !text-[var(--p-text-color-secondary)] text-center w-full text-base ">
                    Place New Bid
                </span>
            </button>

           
        </div>
    </ng-template>

    <ng-template #biddingNoPlaced>
        <button pButton class=" !bg-[var(--community-info-500)] !border-[var(--community-info-500)] 
              hover:!bg-[var(--community-info-600)] hover:!border-[var(--community-info-600)] 
              active:!bg-[var(--community-info-700)] active:!border-[var(--community-info-700)] mt-6 w-full relative flex items-center justify-center"
            (click)="toggleFavorite()">
            <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
            </i>
            <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                {{ itemFavoriteSignal() ? 'Remove from my Favorites' : 'Add to my Favorites' }}
            </span>
        </button>
        <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
            <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
        </p>
    </ng-template>
</ng-template>

}@else{
<!-- <ng-container *ngTemplateOutlet="tplLoadError"></ng-container> -->
}

<ng-template #tplLoadError>

    <div class="flex flex-col items-center justify-center text-center px-6 py-6">
        <div class="flex items-center justify-center w-14 h-14 rounded-full border border-blue-200 bg-white mb-6 ">
            <i class="pi pi-exclamation-circle text-blue-600 text-3xl"></i>
        </div>

        <h2 class="text-xl font-semibold text-gray-900 mb-2"> We couldn't load this information</h2>

        <p class="text-gray-600 max-w-md mb-8">Something went wrong while fetching the data.
            Please try again, or come back in a few moments.</p>

        <div class="flex gap-4">
            <button pButton type="button" severity="info" icon="pi pi-refresh" class="w-[158px] h-[35px]"
                label="Try again">
            </button>
        </div>

    </div>

</ng-template>

<ng-template #OnlineToLiveEvent>
    <div class="bg-[rgba(25,166,223,0.2)] border border-[var(--fs-blue)] rounded-xl p-6 text-center mt-6">

        <h3 class="text-[20px] font-bold text-center font-mulish">Starts Online, Ends at Live Event</h3>

        <p class="text-gray-500 text-sm  font-medium font-mulish">
        Bidding for this item starts online and continues during the Live Event.
            The highest online bid carries forward as the opening bid at the Live Event.
        </p>

        @if(isAbsenteeBiddingEnabled()){
            <p>
            
            <span  class="cursor-pointer ml-2 mr-2 text-[var(--dark-blue)] inline-flex items-center gap-2 font-bold" title="More info"   (click)="displayAbsenteeBiddingModal = true"  >
                    Absentee Bidding
                    <i class="pi pi-question-circle"></i>
                    </span>
                <span class=" text-gray-500 text-sm">available</span>                                         
            </p>
        }
    </div>
</ng-template>
 <app-absentee-bidding [visible]="displayAbsenteeBiddingModal" (close)="displayAbsenteeBiddingModal = false"></app-absentee-bidding>